import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import themeStyle from "../../../assets/jss/eclipse/components/themeStyle.js";
import { primaryColor } from "../../../style.scss";
import { SpinnerComponent } from "react-element-spinner";
import AlertNotification from "../../../components/Snackbar/AlertNotification.js";

const useStyles = makeStyles(themeStyle);

export default function FileCameraButton(props) {
  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();
  const onChangeFile = props?.onChangeFile;
  const buttonText = props?.buttonText ? props?.buttonText : "Let's do it";
  const [alertData, setAlert] = useState(null);
  const allowedFiles = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif"
  ];

  const checkFileExtension = (fileType) => {
    let allowed = false;
    allowedFiles.forEach(extension => {
      if (extension === fileType) {
        allowed = true;
      }
    });
    return allowed;
  }

  const showAlert = (isAlertDisplay, alertType, alertMessage) => {
    setAlert({ isAlertDisplay, alertType, alertMessage })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  var resizeImage = async (settings) => {
    var file = settings.file;
    var maxSize = settings.maxSize;
    var reader = new FileReader();
    var image = new Image();
    var canvas = window.document.createElement('canvas');
    var resize = function () {
      var width = image.width;
      var height = image.height;
      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(image, 0, 0, width, height);
      var dataUrl = canvas.toDataURL(settings?.type, 0.7);
      return dataUrl;
    };

    return new Promise(function (ok, no) {
      if (!file.type.match(/image.*/)) {
        setLoading(false);
        showAlert(true, 'ERROR', `Error while upload image. Please try again.`);
        return;
      }
      reader.onload = function (readerEvent) {
        image.onload = function () { return ok(resize()); };
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const readFile = async (event) => {
    setLoading(true);
    if (!event?.target?.files[0].type) {
      setLoading(false);
      showAlert(true, 'ERROR', `Error while upload image. Please try again.`);
      return;
    }

    const fileType = event.target.files[0].type;
    if (checkFileExtension(fileType)) {
      const pngFile = new Blob([event?.target?.files[0]], { type: fileType });
      const config = {
        file: pngFile,
        maxSize: 1280,
        type: fileType
      };
      const resizedImage = await resizeImage(config);
      setLoading(false);
      onChangeFile(resizedImage);
    } else {
      setLoading(false);
      showAlert(true, 'ERROR', `Error while reading image type. Please try again.`);
    }
  }

  const getButtonCSS = () => {
    return classes.fileUploadButton + ' ' + classes.buttonRadius
  }

  return (
    <>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <label htmlFor="file-upload" className={getButtonCSS()}>
        {buttonText}
      </label>
      <input style={{ display: 'none' }} id="file-upload" type="file" onChange={readFile} size="1" accept="image/*" capture="camera" />
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </>
  );
}